export default {
  bouyguesIcon: {
    id: 'checkout_header_in_store_bouygues_telecom_icon',
    defaultMessage: 'Bouygues Telecom',
  },
  heading: {
    id: 'checkout_bouygues_magic_link_layout_expired_heading',
    defaultMessage: 'Le lien de confirmation a expiré',
  },
  expiredMessage: {
    id: 'checkout_bouygues_magic_link_layout_expired_message',
    defaultMessage:
      'L’achat de votre téléphone avec l’offre Bouygues Telecom ne peut pas être finalisée.',
  },
  infoBlockTitle: {
    id: 'checkout_bouygues_magic_link_layout_info_block_title',
    defaultMessage:
      'La souscription à votre forfait Bouygues Telecom est toujours valable.',
  },
  infoBlockMessage: {
    id: 'checkout_bouygues_magic_link_layout_info_block_message',
    defaultMessage:
      'Contactez le service client Bouygues Telecom par téléphone ou retrouvez votre conseiller en boutique pour annuler votre forfait ou alors pour recommencer l’achat.',
  },
}
